export var MagicIncomingWindowMessage;

(function (MagicIncomingWindowMessage) {
  MagicIncomingWindowMessage["MAGIC_HANDLE_RESPONSE"] = "MAGIC_HANDLE_RESPONSE";
  MagicIncomingWindowMessage["MAGIC_OVERLAY_READY"] = "MAGIC_OVERLAY_READY";
  MagicIncomingWindowMessage["MAGIC_SHOW_OVERLAY"] = "MAGIC_SHOW_OVERLAY";
  MagicIncomingWindowMessage["MAGIC_HIDE_OVERLAY"] = "MAGIC_HIDE_OVERLAY";
  MagicIncomingWindowMessage["MAGIC_HANDLE_EVENT"] = "MAGIC_HANDLE_EVENT";
})(MagicIncomingWindowMessage || (MagicIncomingWindowMessage = {}));

export var MagicOutgoingWindowMessage;

(function (MagicOutgoingWindowMessage) {
  MagicOutgoingWindowMessage["MAGIC_HANDLE_REQUEST"] = "MAGIC_HANDLE_REQUEST";
})(MagicOutgoingWindowMessage || (MagicOutgoingWindowMessage = {}));